export { ReactComponent as IconChevronLeft } from './chevron_left.svg';
export { ReactComponent as IconChevronRight } from './chevron_right.svg';
export { ReactComponent as IconForward } from './forward.svg';
export { ReactComponent as IconBackward } from './backward.svg';
export { ReactComponent as IconFastForward } from './fastforward.svg';
export { ReactComponent as IconInterpolationDisabled } from './interpolation_disabled.svg';
export { ReactComponent as IconInterpolationAdd } from './interpolation_add.svg';
export { ReactComponent as IconInterpolationRemove } from './interpolation_remove.svg';
export { ReactComponent as IconKeypointAdd } from './keypoint_add.svg';
export { ReactComponent as IconKeypointDelete } from './keypoint_delete.svg';
export { ReactComponent as IconKeypointDisabled } from './keypoint_disabled.svg';
export { ReactComponent as IconPlay } from './play.svg';
export { ReactComponent as IconPause } from './pause.svg';
export { ReactComponent as IconRewind } from './rewind.svg';
export { ReactComponent as IconReplay } from './replay.svg';
export { ReactComponent as IconFullscreen } from './fullscreen.svg';
export { ReactComponent as IconFullscreenExit } from './fullscreen_exit.svg';
export { ReactComponent as IconEyeOpened } from './eye_opened.svg';
export { ReactComponent as IconEyeClosed } from './eye_closed.svg';
export { ReactComponent as IconCross } from './cross.svg';
export { ReactComponent as IconCollapse } from './collapse.svg';
export { ReactComponent as IconExpand } from './expand.svg';
export { ReactComponent as IconPrev } from './prev_step.svg';
export { ReactComponent as IconNext } from './next_step.svg';
export { ReactComponent as IconConfig } from './config.svg';
export { ReactComponent as IconSoundConfig } from './sound.svg';
export { ReactComponent as IconSoundMutedConfig } from './sound_muted.svg';
export { ReactComponent as IconInfoConfig } from './info.svg';
